import { render, staticRenderFns } from "./FormularioTicketInstalacaoComponent.vue?vue&type=template&id=51c2828c&scoped=true"
import script from "./FormularioTicketInstalacaoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioTicketInstalacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./FormularioTicketInstalacaoComponent.vue?vue&type=style&index=0&id=51c2828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2828c",
  null
  
)

export default component.exports